import { Component } from '@angular/core';

@Component({
  selector: 'spark-core-coming-soon',
  templateUrl: './coming-soon.component.html'
})
export class ComingSoonComponent {
  constructor() {}
}
